export default {
      id: "art-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/icons.68fd9e19.svg#art",
      toString: function () {
        return this.url;
      }
    }